import { colorsPalettes } from "@similarweb/styles";
import { bounceInAnimation, fadeInAnimation } from "app/pages/sales-intelligence/common-components/animations";
import type { IconTheme } from "app/pages/sales-intelligence/types/styles";
import styled, { css } from "styled-components";
import { IndicatorThemeType } from "./types";

const INDICATOR_SIZE_XY = 10;

const indicatorDimensions = css`
    height: ${INDICATOR_SIZE_XY}px;
    width: ${INDICATOR_SIZE_XY}px;
`;

const indicatorTheme: Record<IndicatorThemeType, IconTheme> = {
    [IndicatorThemeType.Pending]: {
        fill: colorsPalettes.red["s100"],
        border: colorsPalettes.red[100],
    },
    [IndicatorThemeType.Stale]: {
        fill: colorsPalettes.carbon[400],
        border: colorsPalettes.bluegrey[100],
    },
};

export const StyledSuggestionsIndicator = styled.div<{
    themeType: IndicatorThemeType;
    isVisible: boolean;
    withBounceAnimation: boolean;
}>`
    position: relative;
    width: fit-content;

    &:after {
        content: "";
        position: absolute;
        top: 4px;
        right: 4px;

        opacity: 0;

        ${indicatorDimensions};

        background-color: ${({ themeType }) => indicatorTheme[themeType].fill};
        border: 2px solid ${({ themeType }) => indicatorTheme[themeType].border};
        border-radius: 50%;

        ${({ withBounceAnimation, isVisible }) => {
            if (withBounceAnimation) {
                return css`
                    animation-name: ${fadeInAnimation}, ${bounceInAnimation};
                    animation-delay: 2s, 4s;
                    animation-duration: 150ms, 2s;
                    animation-iteration-count: 1, 5;
                    animation-fill-mode: both, forwards;
                `;
            }

            if (isVisible) {
                return css`
                    animation-name: ${fadeInAnimation};
                    animation-delay: 100ms;
                    animation-duration: 150ms;
                    animation-fill-mode: both;
                `;
            }
        }};
    }
`;
